import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Color, Text } from '../../styles/common';
import { auth } from '../../services/firebase.service';

function Header() {
  // 로그아웃
  const onSignOutClick = () => {
    auth.signOut();
    alert('안녕히 가세요.');
  }

  return (
    <Container>
      <Inner>
        <img src='/images/logo.png' alt='header-logo' />
        <ul>
          <li><Link to='/'>Home</Link></li>
          <li onClick={onSignOutClick}>Sign out</li>
        </ul>
      </Inner>
    </Container>
  )
}

export default Header;

const Container = styled.header`
  width: 100%;
  position: fixed;
  top: 0;
  padding: 20px;
  background-color: ${ Color.WHITE };
  z-index: 999;
`

const Inner = styled.div`
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  font-size: ${ Text.SM };
  color: ${ Color. GRAY200 };

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  img {
    width: 120px;
    cursor: pointer;
  }

  ul {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 20px;

    li {
      list-style: none;
      cursor: pointer;

      &:hover {
          color: ${ Color.BLUE100 };
          text-decoration: underline;
        }

      a {
        color: ${ Color.BLACK };
        text-decoration: none;

        &:hover {
          color: ${ Color.BLUE100 };
        }
      }
    }
  }
`